import { Injectable } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Account } from '../../model';
import { ContextService } from '../../services/context.service';
import { RestApiService } from '../../services/rest-api.service';

@Injectable({
  providedIn: 'root',
})
export class InitializeAppService {
  constructor(
    private authService: AuthService,
    private contextService: ContextService,
    private apiService: RestApiService,
  ) {}

  async initializeApp(): Promise<void> {
    const accountId = this.authService.getAccountIdFromToken();
    if (accountId) {
      this.authService.setCurrentAccountId(accountId);
    }
    await this.setUserAccounts();
    return Promise.resolve();
  }

  private async setUserAccounts() {
    const id = this.authService.getAccountIdFromToken();
    if (!id) {
      this.authService.logout();
      return;
    }
    const accounts: Account[] = await this.getAccounts(id);
    this.contextService.setUserAccounts(accounts);
  }

  private getAccounts(accountId: string): Promise<Account[]> {
    return this.apiService.get<Account[]>(`Accounts/Under?accountId=${accountId}`);
  }
}
